import React, { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  orderBy,
  limit,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import "./ExchageMoney.css";

const ExchangeMoney = () => {
  const [user, setUser] = useState(() => {
    // 🟢 ANZA NA LOCAL STORAGE ILI ISICHELEWE
    const cached = localStorage.getItem("user");
    if (cached) {
      try {
        const data = JSON.parse(cached);
        return {
          ...data,
          usdtBalance: Number(data.usdtBalance || 0),
          tshBalance: Number(data.tshBalance || 0),
        };
      } catch {
        return null;
      }
    }
    return null;
  });

  const [exchangeDirection, setExchangeDirection] = useState("usdtToTsh");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loadingUser, setLoadingUser] = useState(false);
  const [userDocId, setUserDocId] = useState(null);
  const [history, setHistory] = useState([]);

  const exchangeRate = 2500;
  const username = localStorage.getItem("username");

  // ===================== HISTORY =====================
  const fetchHistory = async (userName) => {
    if (!userName) return;
    try {
      const exchRef = collection(db, "exchangeLogs");
      const qHist = query(
        exchRef,
        where("username", "==", userName),
        orderBy("timestamp", "desc"),
        limit(10)
      );
      const snap = await getDocs(qHist);
      const histData = snap.docs.map((d) => d.data());
      setHistory(histData);
    } catch (err) {
      console.error("History error:", err);
    }
  };

  // ===================== FETCH USER FROM FIRESTORE =====================
  useEffect(() => {
    if (!username) return;

    const fetchUser = async () => {
      try {
        setLoadingUser(true);
        const usersRef = collection(db, "users");
        // 🔴 HAPA ULIKUA NA MAKOSA YA QUERY, IMEREKEBISHWA
        const qUser = query(usersRef, where("username", "==", username));
        const snap = await getDocs(qUser);

        if (!snap.empty) {
          const data = snap.docs[0].data();
          const cleanUser = {
            ...data,
            usdtBalance: Number(data.usdtBalance || 0),
            tshBalance: Number(data.tshBalance || 0),
          };
          setUser(cleanUser);
          setUserDocId(snap.docs[0].id);

          // 🟢 UPDATE LOCAL STORAGE PIA
          localStorage.setItem("user", JSON.stringify(cleanUser));

          fetchHistory(username);
        }
      } catch (err) {
        console.error("Fetch user error:", err);
      } finally {
        setLoadingUser(false);
      }
    };

    fetchUser();
  }, [username]);

  // ===================== MAX BUTTON =====================
  const handleMax = () => {
    if (!user) return;
    setAmount(
      exchangeDirection === "usdtToTsh"
        ? user.usdtBalance
        : user.tshBalance
    );
  };

  // ===================== EXCHANGE =====================
  const handleExchange = async () => {
    if (!amount || amount <= 0) {
      setError("Weka kiasi halali.");
      return;
    }
    if (!user || !userDocId) {
      setError("User data haijapakiwa vizuri.");
      return;
    }

    setError("");
    setSuccess("");

    const amt = Number(amount);
    let updateData = {};
    let successMsg = "";

    try {
      const userRef = doc(db, "users", userDocId);

      if (exchangeDirection === "usdtToTsh") {
        if (amt > user.usdtBalance) {
          setError("USDT haitoshi.");
          return;
        }

        const tshToAdd = amt * exchangeRate;

        updateData = {
          usdtBalance: user.usdtBalance - amt,
          tshBalance: user.tshBalance + tshToAdd,
        };

        successMsg = `✓ ${amt.toFixed(2)} USDT → ${tshToAdd.toFixed(2)} TSH;`

        await addDoc(collection(db, "exchangeLogs"), {
          username,
          type: "USDT→TSH",
          fromAmount: amt,
          toAmount: tshToAdd,
          commission: 0,
          timestamp: serverTimestamp(),
        });
      } else {
        if (amt > user.tshBalance) {
          setError("TSH haitoshi.");
          return;
        }

        const usdtToAdd = amt / exchangeRate;

        updateData = {
          tshBalance: user.tshBalance - amt,
          usdtBalance: user.usdtBalance + usdtToAdd,
        };

        successMsg = `✓ ${amt.toFixed(2)} TSH → ${usdtToAdd.toFixed(4)} USDT;`

        await addDoc(collection(db, "exchangeLogs"), {
          username,
          type: "TSH→USDT",
          fromAmount: amt,
          toAmount: usdtToAdd,
          commission: 0,
          timestamp: serverTimestamp(),
        });
      }

      // 🔹 UPDATE FIRESTORE
      await updateDoc(userRef, updateData);

      // 🔹 UPDATE STATE
      setUser((prev) => {
        const newUser = {
          ...prev,
          ...updateData,
        };
        // 🔹 UPDATE LOCAL STORAGE PIA ILI BANNER NA SEHEMU NYINGINE ZIONE HARAKA
        localStorage.setItem("user", JSON.stringify(newUser));
        return newUser;
      });

      setSuccess(successMsg);
      setAmount("");
      fetchHistory(username);
    } catch (err) {
      console.error(err);
      setError("Hitilafu imetokea.");
    }
  };

  if (!username) {
    return <p style={{ padding: 16 }}>Login kwanza.</p>;
  }

  if (!user && loadingUser) {
    return <p style={{ padding: 16 }}>Loading...</p>;
  }

  if (!user && !loadingUser) {
    return <p style={{ padding: 16 }}>User data haijapatikana.</p>;
  }

  const availableText =
    exchangeDirection === "usdtToTsh"
      ? `${user.usdtBalance.toFixed(2)} USDT`
      : `${user.tshBalance.toFixed(2)} TSH;`

  return (
    <div className="exchange-container">
      <h2 className="transfer-title">Transfer</h2>

      {/* FROM / TO BOX */}
      <div className="transfer-box">
        <div className="row">
          <span className="label">From</span>
          <span className="value">
            {exchangeDirection === "usdtToTsh" ? "USDT Wallet" : "TSH Wallet"}
          </span>
        </div>

        <div className="switch-arrow">⇅</div>

        <div className="row">
          <span className="label">To</span>
          <span className="value">
            {exchangeDirection === "usdtToTsh" ? "TSH Wallet" : "USDT Wallet"}
          </span>
        </div>
      </div>

      {/* ASSET */}
      <div className="section">
        <span className="label">Asset</span>
        <select
          value={exchangeDirection}
          onChange={(e) => setExchangeDirection(e.target.value)}
          className="select-input"
        >
          <option value="usdtToTsh">USDT → TSH</option>
          <option value="tshToUsdt">TSH → USDT</option>
        </select>
      </div>

      {/* AMOUNT */}
      <div className="section">
        <span className="label">Amount</span>

        <div className="amount-box">
          <input
            type="number"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          <span className="asset-tag">
            {exchangeDirection === "usdtToTsh" ? "USDT" : "TSH"}
          </span>
          <button className="max-btn" onClick={handleMax}>
            Max
          </button>
        </div>

        <small className="available">Available: {availableText}</small>
      </div>

      {/* CONFIRM */}
      <button className="confirm-btn" onClick={handleExchange}>
        Confirm
      </button>

      {error && <p className="error-msg">{error}</p>}
      {success && <p className="success-msg">{success}</p>}
    </div>
  );
};

export default ExchangeMoney;